import { useModalStore } from '@/shared/lib';
import { PaidInvoicesListModal } from '../ui';
import type { PaidInvoicesListModalProps } from './types';

const usePaidInvoicesListModal = () => {
  const { showDialogComponent } = useModalStore();

  const openPaidInvoicesListModal = ({
    params,
    onBack,
  }: PaidInvoicesListModalProps) => {
    showDialogComponent({
      component: <PaidInvoicesListModal params={params} onBack={onBack} />,
      className: 'border-0',
    });
  };

  return { openPaidInvoicesListModal };
};

export { usePaidInvoicesListModal };
